module.exports = __webpack_public_path__ + "static/aboleth-mtg_clb-89e96c94c92f22da528cceb3443068e0.jpg";